import {
  NewsletterButton,
  NewsletterContainer,
  NewsletterDescription,
  NewsletterInput,
  NewsletterInputAndButton,
  NewsletterLeft,
  NewsletterRight,
  NewsletterTitle,
  NewsletterWrapper,
} from "./NewsletterStyles";

function Newsletter() {
  return (
    <NewsletterWrapper>
      <NewsletterContainer>
        <NewsletterLeft>
          <NewsletterTitle>Nieuwsbrief</NewsletterTitle>
          <NewsletterDescription>
            Meld je aan voor onze nieuwsbrief om updates, nieuws of artikelen te
            ontvangen.
          </NewsletterDescription>
        </NewsletterLeft>
        <NewsletterRight>
          <NewsletterInputAndButton>
            <NewsletterInput placeholder="Emailadres" />
            <NewsletterButton>Inschrijven</NewsletterButton>
          </NewsletterInputAndButton>
        </NewsletterRight>
      </NewsletterContainer>
    </NewsletterWrapper>
  );
}

export default Newsletter;
